import { UseSlatePlugin } from "components/slate/types";
import { withNodeId } from "components/slate/plugins/nodeId/withNodeId";

const useNodeIdPlugin: UseSlatePlugin = () => {
  return {
    withOverrides: withNodeId,
  };
};

export default useNodeIdPlugin;
